<template>
  <form id="app" @submit.prevent="send()" novalidate>
    <div class="mb-5">
      <p class="form-text text-muted float-right">* Pflichtfeld</p>
      <h6 class="font-weight-bold">Ich interessiere mich für Projektpreise von: *</h6>
      <div class="custom-control custom-checkbox py-1">
        <input
          type="checkbox"
          class="custom-control-input"
          id="elgato"
          @change="projektpreiseVon('Elgato')"
          ref="priceElgato"
        />
        <label class="custom-control-label" for="elgato">Elgato</label>
      </div>
      <div class="custom-control custom-checkbox py-1">
        <input
          type="checkbox"
          class="custom-control-input"
          id="targus"
          @change="projektpreiseVon('Targus')"
          ref="priceTargus"
        />
        <label class="custom-control-label" for="targus">Targus</label>
      </div>
      <div class="custom-control custom-checkbox py-1">
        <input
          type="checkbox"
          class="custom-control-input"
          id="wacom"
          @change="projektpreiseVon('Wacom')"
          ref="priceWacom"
        />
        <label class="custom-control-label" for="wacom">Wacom</label>
        <!-- <div class="invalid-feedback">Bitte mindestens einen auswählen</div> -->
      </div>
      <div class="custom-control custom-checkbox py-1">
        <input
          type="checkbox"
          class="custom-control-input"
          id="western-digital"
          @change="projektpreiseVon('Western Digital')"
          ref="priceWestern"
        />
        <label class="custom-control-label" for="western-digital">Western Digital</label>
      </div>
      
    </div>
    <div class="mb-5">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="salutation">Anrede *</label>
            <select
              class="custom-select"
              name="salutation"
              id="salutation"
              required
              v-model="anrede"
              @change="salutation()"
              ref="salutation"
            >
              <option disabled selected value="">Bitte auswählen</option>
              <option value="Frau">Frau</option>
              <option value="Herr">Herr</option>
            </select>
            <div class="invalid-feedback">Bitte auswählen</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="name">Vorname *</label>
            <input
              type="text"
              class="form-control"
              name="name"
              id="name"
              @input="name()"
              ref="firstname"
              required
              v-model="vorname"
            />
            <div class="invalid-feedback">Bitte ausfüllen</div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="surname">Nachname *</label>
            <input
              type="text"
              class="form-control"
              name="surname"
              id="surname"
              @input="surname()"
              ref="surname"
              required
              v-model="nachname"
            />
            <div class="invalid-feedback">Bitte ausfüllen</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="email">E-Mail-Adresse *</label>
            <input
              type="email"
              class="form-control"
              name="email"
              id="email"
              @input="mail()"
              ref="mail"
              required
              v-model="email"
            />
            <div class="invalid-feedback">Bitte gültige E-Mail-Adresse eingeben</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="company">Unternehmen *</label>
            <input
              type="text"
              class="form-control"
              name="company"
              id="company"
              @input="company()"
              ref="company"
              required
              v-model="firma"
            />
            <div class="invalid-feedback">Bitte ausfüllen</div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="customernumber">Kundennummer</label>
            <input
              type="text"
              class="form-control"
              name="customernumber"
              id="customernumber"
              @input="knummer()"
              ref="customernumber"
              required
              v-model="kundennummer"
            />
            <div class="invalid-feedback">Bitte ausfüllen</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <label for="comment">Bemerkung</label>
          <textarea class="form-control" name="comment" id="comment" rows="8" v-model="bemerkung"></textarea>
        </div>
      </div>
    </div>
    <!--
    <div class="mb-5">
      <h4>Sie haben noch Fragen oder Wünsche?</h4>
      <p>Dann kontaktieren Sie Katrin Johannsen.</p>
      <table>
        <tr>
          <td>E-Mail:</td>
          <td>
            <a href="mailto:katrin.johannsen@comline-shop.de"
              >katrin.johannsen@comline-shop.de</a
            >
          </td>
        </tr>
        <tr>
          <td>Telefon:</td>
          <td><a href="tel:046177303502">0461 77303-502</a></td>
        </tr>
      </table>
    </div> -->

    <div class="mb-5">
      <div class="form-group">
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            name="privacypolicy"
            id="privacypolicy"
            @change="privacy()"
            ref="privacy"
            required
            v-model="datenschutz"
          />
          <label class="custom-control-label" for="privacypolicy"
            >Ja, ich akzeptiere die
            <a href="https://www.comline-shop.de/datenschutz/" target="_blank">Datenschutzbestimmungen</a>
            *</label
          >
        </div>
      </div>
    </div>
    <div>
      <div class="alert alert-danger" v-if="isntComplete.length">
        <b>Bitte füllen Sie folgende Felder aus:</b>
        <ul>
          <li v-for="isntCompleted in isntComplete" v-bind:key="isntCompleted.id">
            {{ isntCompleted }}
          </li>
        </ul>
      </div>
      <button type="submit" class="btn btn-primary" id="form-submit" v-if="!isSaved">
        <div class="spinner-border spinner-border-sm" id="spinner" v-if="clickedSend"></div>
        Projektpreis anfordern
      </button>
      <div class="alert alert-success" v-if="isSaved && clickedSend">Sie haben sich erfolgreich angemeldet.</div>
      <div class="alert alert-danger" v-if="isntSaved && clickedSend">Es ist ein Fehler aufgetreten.</div>
    </div>
  </form>
</template>

<script>
//import { firestore, collection, addDoc } from "../plugins/firebase";
import isEmail from "validator/es/lib/isEmail";

//Ablage:  getDoc

export default {
  name: "PreisanfrageFormular",
  mounted() {},
  data() {
    return {
      preiseVon: [],
      anrede: "",
      vorname: "",
      nachname: "",
      email: "",
      firma: "",
      kundennummer: "",
      bemerkung: "",
      datenschutz: "",
      sendState: "",
      sendSuccess: "",
      clickedSend: false,
      isSaved: false,
      isntSaved: false,
      isntComplete: [],
    };
  },
  methods: {
    projektpreiseVon: function (payload) {
      if (this.preiseVon.includes(payload)) {
        let indexOf = this.preiseVon.indexOf(payload);
        this.preiseVon.splice(indexOf, 1);
      } else {
        this.preiseVon.unshift(payload);
      }
      this.isPreiseVon();
    },
    isPreiseVon: function () {
      if (this.preiseVon.length === 0) {
        // this.$refs.priceEizo.classList.add("is-invalid");
        this.$refs.priceElgato.classList.add("is-invalid");
        this.$refs.priceTargus.classList.add("is-invalid");
        this.$refs.priceWestern.classList.add("is-invalid");
        this.$refs.priceWacom.classList.add("is-invalid");
      } else {
        // this.$refs.priceEizo.classList.remove("is-invalid");
        this.$refs.priceElgato.classList.remove("is-invalid");
        this.$refs.priceTargus.classList.remove("is-invalid");
        this.$refs.priceWestern.classList.remove("is-invalid");
        this.$refs.priceWacom.classList.remove("is-invalid");
        this.deleteEvent("Interesse an Projektpreisen von...");
      }
    },
    salutation: function () {
      if (this.anrede === "") {
        this.$refs.salutation.classList.add("is-invalid");
      } else {
        this.$refs.salutation.classList.remove("is-invalid");
        this.deleteEvent("Anrede");
      }
    },
    name: function () {
      if (this.vorname === "") {
        this.$refs.firstname.classList.add("is-invalid");
      } else {
        this.$refs.firstname.classList.remove("is-invalid");
        this.deleteEvent("Vorname");
      }
    },
    surname: function () {
      if (this.nachname === "") {
        this.$refs.surname.classList.add("is-invalid");
      } else {
        this.$refs.surname.classList.remove("is-invalid");
        this.deleteEvent("Nachname");
      }
    },
    mail: function () {
      if (isEmail(this.email) === false) {
        this.$refs.mail.classList.add("is-invalid");
      } else {
        this.$refs.mail.classList.remove("is-invalid");
        this.deleteEvent("E-Mail Adresse");
      }
    },
    company: function () {
      if (this.firma === "") {
        this.$refs.company.classList.add("is-invalid");
      } else {
        this.$refs.company.classList.remove("is-invalid");
        this.deleteEvent("Firma");
      }
    },
    knummer: function () {
      if (this.kundennummer === "") {
        // this.$refs.customernumber.classList.add("is-invalid");
        this.kundennummer = "keine Kundennummer";
      } else {
        this.$refs.customernumber.classList.remove("is-invalid");
        this.deleteEvent("Kundennummer");
      }
    },
    privacy: function () {
      if (!this.datenschutz) {
        this.$refs.privacy.classList.add("is-invalid");
      } else {
        this.$refs.privacy.classList.remove("is-invalid");
        this.deleteEvent("Datenschutz");
      }
    },
    deleteEvent: function (event) {
      this.isntComplete = this.isntComplete.filter((word) => word !== event);
    },
    checkInput: function () {
      this.isPreiseVon();
      this.privacy();
      this.salutation();
      this.name();
      this.surname();
      this.mail();
      this.company();
      //  this.knummer();

      this.isntComplete = [];
      if (this.preiseVon.length === 0) {
        this.isntComplete.push("Interesse an Projektpreisen von...");
      }
      if (this.datenschutz !== true) {
        this.isntComplete.push("Datenschutz");
      }
      if (this.anrede === "") {
        this.isntComplete.push("Anrede");
      }
      if (this.vorname === "") {
        this.isntComplete.push("Vorname");
      }
      if (this.nachname === "") {
        this.isntComplete.push("Nachname");
      }
      if (isEmail(this.email) === false) {
        this.isntComplete.push("E-Mail Adresse");
      }
      if (this.firma === "") {
        this.isntComplete.push("Firma");
      }
      /* if (this.kundennummer === "") {
        this.isntComplete.push("Kundennummer");
      } */
      if (!this.isntComplete.length && this.sendState !== true && this.sendSuccess !== true) {
        return true;
      } else {
        return false;
      }
    },
    send: async function () {
      if (this.checkInput() === true) {
        this.clickedSend = true;
        console.log(isEmail(this.email));
        // Add a new document with a generated id.

        await this.$addDoc(this.$collection(this.$firestore, "preisanfragen"), {
          preiseVon: "<ul><li>" + this.preiseVon.join("</li><li>") + "</ul>",
          anrede: this.anrede,
          bemerkung: this.bemerkung,
          datenschutz: this.datenschutz,
          email: this.email,
          firma: this.firma,
          kundennummer: this.kundennummer,
          nachname: this.nachname,
          vorname: this.vorname,
        });

        this.isSaved = true;
        /* .then(() => {
            this.isSaved = true;
          })
          .catch((error) => {
            window.console.error(error); 
          });*/
      }
    },
  },
};
</script>

<style scoped>
#app {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: left;
  color: #505153;
}

.btn-primary {
  background-color: rgba(64, 137, 201, 1);
  border-color: transparent;
}
.btn-primary:hover {
  color: #fff;
  background-color: #286090;
  border-color: #204d74;
}

a {
  color: rgba(64, 137, 201, 1);
}
a:hover {
  color: #286090;
}
</style>
